import React from "react";
import './bgBefore.css';

const BgBefore = () => {
    return (
        <>
         <div className="jumbotron jumbotron-fluid hero-banner">
              <div className="container">
                <h1 className="display-4">Noor Capital</h1>
                <p>Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC.</p>
              </div>
        </div>
        </>
    )

};

export default BgBefore;
